import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import HeaderUser from "./content/header";
import Footer from "./content/footer"
import {Helmet} from 'react-helmet'


import AllCoursesIndex from "./content/allcoursesbycategoria"

class Posgraduacaobycategoria extends Component {


 

  render() {
    return (
      <React.Fragment>
        
        <HeaderUser />
        <br></br>
        <AllCoursesIndex />


      
      <br></br>
      <Footer />
      </React.Fragment>
       
    );
  }
}

export default withRouter(Posgraduacaobycategoria);


// WEBPACK FOOTER //
// ./src/pages/posgraduacaobycategoria.js